<hr class="separator d-none d-lg-block" />

<!-- MOBILE LAYOUT -->
<div *ngIf="isMobile$ | async; else desktopTemplate">
    <fieldset [disabled]="true">
        <div *ngFor="let entry of otherTimeSheetEntries; index as $index">
            <div
                class="row mt-3 mb-4 align-items-start"
                [ngClass]="{ 'alert alert-warning timesheet-entries': isOverlapping(entry) }"
            >
                <!-- START DATE AND TIME -->
                <div class="col-12">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"> </label>
                </div>
                <div class="col-7">
                    <pace-core-date-input
                        [(model)]="entry.startDate"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                    ></pace-core-date-input>
                </div>
                <div class="col-5">
                    <pace-core-time-input
                        [(model)]="entry.startTime"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                    ></pace-core-time-input>
                </div>
                <!-- End Date and Time-->
                <div class="col-12">
                    <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"> </label>
                </div>
                <div class="col-7">
                    <pace-core-date-input
                        [(model)]="entry.endDate"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                    ></pace-core-date-input>
                </div>
                <div class="col col-lg-5">
                    <pace-core-time-input
                        [(model)]="entry.endTime"
                        [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                    ></pace-core-time-input>
                </div>

                <!-- Right hand block - Activity and Notification -->
                <div class="col-12 mt-3">
                    <div class="row">
                        <div class="col-4 text-start">
                            <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_ACTIVITY">
                            </label>
                        </div>
                        <label class="col no-call-outs col-form-label fw-normal text-start">{{ getDesc(entry) }}</label>
                    </div>
                </div>

                <div class="col-12 mt-3">
                    <div class="row">
                        <div class="col-4 align-items-center justify-content-between">
                            <label
                                class="col-form-label"
                                translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_NOTIFICATION"
                            >
                            </label>
                        </div>
                        <label
                            *ngIf="entry.notificationId.qmNum; else isManualEntry"
                            class="col no-call-outs col-form-label fw-normal text-start"
                            >{{ entry.notificationId.qmNum }} ({{ entry.notificationId.maNum }})</label
                        >
                        <ng-template #isManualEntry>
                            <div class="row">
                                <label
                                    *ngIf="entry.address && entry.address.addrText.value"
                                    class="col-6 no-call-outs"
                                    >{{ entry.address.addrText.value }}</label
                                >

                                <label
                                    *ngIf="entry.address && !entry.address.addrText.value && entry.address.city.value"
                                    class="col no-call-outs"
                                    >{{ entry.address.city.value }}</label
                                >
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <hr *ngIf="$index < otherTimeSheetEntries.length - 1" class="separator" />
        </div>
    </fieldset>
</div>
<!-- END OF MOBILE LAYOUT-->

<!-- DESKTOP LAYOUT -->
<ng-template #desktopTemplate>
    <fieldset [disabled]="true">
        <div class="row mb-3">
            <div class="col-1 limited-col-width"></div>
            <div class="col-6 ps-0">
                <label class="col-form-label">
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"></span>
                    <span class="px-1">/</span>
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"></span>
                </label>
            </div>
            <div class="col-2">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_OTHER_ACTIVITY"> </label>
            </div>
            <div class="col">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_OTHER_NOTIFICATION"> </label>
            </div>
        </div>

        <div *ngFor="let entry of otherTimeSheetEntries; index as $index">
            <div
                class="row mt-3 mb-4 align-items-start"
                [ngClass]="{ 'alert alert-warning timesheet-entries': isOverlapping(entry) }"
            >
                <div class="col-1 limited-col-width px-0"></div>

                <!-- Left hand block - date and time entries -->
                <div class="col-6">
                    <!-- START DATE AND TIME -->
                    <div class="row gap-2">
                        <div class="col-5 p-0">
                            <pace-core-date-input
                                [(model)]="entry.startDate"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-3 p-0">
                            <pace-core-time-input
                                [(model)]="entry.startTime"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                    <!-- End Date and Time-->
                    <div class="row gap-2 mt-1">
                        <div class="col-5 p-0">
                            <pace-core-date-input
                                [(model)]="entry.endDate"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                            ></pace-core-date-input>
                        </div>
                        <div class="col-3 p-0">
                            <pace-core-time-input
                                [(model)]="entry.endTime"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>

                <!-- Right hand block - Activity and Notification -->
                <div class="col-4">
                    <div class="row">
                        <div class="col-6 align-items-center justify-content-between">
                            <label class="no-call-outs col-form-label fw-normal text-start">{{ getDesc(entry) }}</label>
                        </div>
                        <div class="col align-items-center justify-content-between">
                            <label
                                *ngIf="entry.notificationId.qmNum; else isManualEntry"
                                class="no-call-outs col-form-label fw-normal text-start"
                                >{{ entry.notificationId.qmNum }} ({{ entry.notificationId.maNum }})</label
                            >
                        </div>
                        <ng-template #isManualEntry>
                            <div class="row">
                                <label
                                    *ngIf="entry.address && entry.address.addrText.value"
                                    class="col-6 no-call-outs"
                                    >{{ entry.address.addrText.value }}</label
                                >
                                <label
                                    *ngIf="entry.address && !entry.address.addrText.value && entry.address.city.value"
                                    class="col no-call-outs"
                                    >{{ entry.address.city.value }}</label
                                >
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</ng-template>
<!-- END OF DESKTOP LAYOUT-->
